import { FC } from "react"
import style from "./style.module.css"
import VkAuthButton from "./AuthButtons/VkAuthButton"
import YandexAuthButton from "./AuthButtons/YandexAuthButton"

const SocialLinks: FC = () => {
  return (
    <div className={style.social_container}>
      <span className={style.title}>Войти с помощью:</span>
      <div className={style.image_box}>
        <VkAuthButton />
        <YandexAuthButton />
      </div>
    </div>
  )
}

export default SocialLinks
